// import logo from './logo.svg';
import "./App.css";
import "./components/style.css";

import { useState } from "react";

import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home_working";
// import Home from "./pages/Home";
import Order from "./pages/Order";
import Basket from "./pages/Basket";
import Search from "./pages/Search";
import Profile from "./pages/Profile";
import Login from "./auth/Login";
import Test from "./auth/Test";
// import Signup from "./auth/Signup";
import ProtectedRoutes from "./components/ProtectedRoutes";
import Delivery from "./pages/Delivery";
import Courier from "./pages/Courier";
import CourierInvoice from "./pages/CourierInvoice";
import LocationSelection from "./pages/LocationSelection";
import SelectVehicle from "./pages/SelectVehicle";

import Item from "./pages/Item";
import Company from "./pages/Company";
import Store from "./pages/Store";
import SingleStore from "./pages/SingleStore";
import FooterPanel from "./components/FooterPanel";
import Locations from "./pages/Locations";
import ActiveOrderDetail from "./pages/ActiveOrderDetail";
import OrderHistoryDetail from "./pages/OrderHistoryDetail";
import Wallet from "./pages/Wallet";
import ProviderRating from "./pages/ProviderRating";
import StoreRating from "./pages/StoreRating";

import { useSelector } from "react-redux";
// import ScriptTag from 'react-script-tag';

import auth from "./auth/auth";
import { useEffect } from "react";
import Payment from "./pages/Payment";
import ErrorDialog from "./components/ErrorDialog";
// import './services/xm'

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [authed, setAuthed] = useState(false);
  const [cart, setCart] = useState([]);
  const new_cart = useSelector((state) => state.cart);
  const error = useSelector((state) => state.error);
  // function AddLibrary(urlOfTheLibrary) {
  //   const script = document.createElement('script');
  //   script.src = urlOfTheLibrary;
  //   script.async = true;
  //   document.body.appendChild(script);
  // }
  console.log("this is ss s ss ssthe console");
  // console.log(window);
  console.log("window.xm", window.xm);
  console.log(new window.VConsole());
  // let loading = window.weui.loading('loading', {});
  // console.log(loading)
  const handleCart = (product) => {
    let isPresent = false;

    if (cart.length === 0) {
      localStorage.setItem("store_id", product.store_id);
      setCart([...cart, product]);
    } else {
      const previousStore = localStorage.getItem("store_id");
      if (previousStore === product.store_id) {
        cart.forEach((item) => {
          if (item._id === product._id) {
            isPresent = true;
          }
        });
        if (isPresent) return;
        setCart([...cart, product]);
      } else {
        localStorage.setItem("store_id", product.store_id);
        setCart([product]);
      }
    }
  };
  const handleCartSpec = (product, item) => {
    // console.log("item", item);
    // console.log("product", product.specifications);
    var temp_prod = product;
    temp_prod.specifications = [];
    temp_prod.specifications.push(item);
    // console.log(temp_prod);
    handleCart(temp_prod);
    // product.specifications = temp
  };
  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  // const check = auth.isAuthenticated();
  // if (check === true){

  // }
  useEffect(() => {
    const date = new Date();
    let day = date.getDay();
    const hour = date.getHours();
    // console.log(hour);
    let nav = auth.isAuthenticated();
    if (nav === "true") {
      setAuthed(true);
    }
  }, []);
  return (
    <HashRouter>
      {/* <ScriptTag isHydrating={true} type="text/javascript" 
      src="xm.js"/> */}
      <div className="App">
        <div className="contents">
          {/* <ScrollRestoration/> */}
          {/* { authed ?<Navbar carts={new_cart.length} cart={new_cart} logout={()=>{logout()}}/>: null } */}
          <Routes>
            {/* <Route path="/" element={<Login />} /> */}
            <Route path="/" element={<Test />} />
            {/* <Route path="/signup" element={<Signup />} /> */}
            {/* <Route path="/login" element={<Login />} /> */}
            <Route path="/login" element={<Test />} />
            <Route element={<ProtectedRoutes />}>
              <Route path="/home" element={<Home handleCart={handleCart} />} />
              <Route path="/order" element={<Order />} />
              <Route path="/search" element={<Search />} />
              <Route
                path="/basket"
                element={<Basket cart={new_cart} handleCart={handleCart} />}
              />
              <Route
                path="/profile"
                element={
                  <Profile
                    logout={() => {
                      logout();
                    }}
                  />
                }
              />
              <Route path="/delivery/:id" element={<Delivery />} />
              <Route path="/courier/:id" element={<Courier />} />
              <Route path="/courier/invocie" element={<CourierInvoice />} />

              <Route path="/kcolocations" element={<LocationSelection />} />
              <Route path="/select-vehicle" element={<SelectVehicle />} />

              <Route
                path="/item/:id"
                element={
                  <Item
                    cart={cart}
                    handleCart={handleCart}
                    handleCartSpec={handleCartSpec}
                  />
                }
              />
              <Route path="/company/:id" element={<Company />} />
              <Route path="store/:id" element={<Store />} />
              <Route
                path="singleStor/:id"
                element={<SingleStore handleCart={handleCart} />}
              />
              <Route
                path="payment/:id"
                element={<Payment handleCart={handleCart} />}
              />
              <Route
                path="/locations"
                element={<Locations />}
                logout={logout}
              />
              <Route
                path="/active-order-detail"
                element={<ActiveOrderDetail />}
              />
              <Route
                path="/order-history-detail"
                element={<OrderHistoryDetail />}
              />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/provider-rating" element={<ProviderRating />} />
              <Route path="/store-rating" element={<StoreRating />} />
            </Route>
          </Routes>
        </div>
        {error ? <ErrorDialog open={error} /> : null}
        <ToastContainer />
        {/* <ErrorDialog open={error}/> */}
        {authed ? <FooterPanel /> : ""}
        {/* {authed ? <Home /> : ""} */}
      </div>
    </HashRouter>
  );
}

export default App;
